import { highlightFeatures } from './feature_highlight';
import bp from '../breakpoints';

export default function domContentLoaded() {
  if (bp.getBreakpointSize() === 'lg') {
    highlightFeatures();
    return true;
  }
  return false;
}

document.addEventListener('DOMContentLoaded', domContentLoaded);



// WEBPACK FOOTER //
// ./feature_highlight/feature_highlight_options.js